import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=13c6841b&"
import script from "./topics.vue?vue&type=script&lang=ts&"
export * from "./topics.vue?vue&type=script&lang=ts&"
import style0 from "./topics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports